import React from 'react';
import { Typography } from 'antd';
import { FileImageOutlined, FilePdfOutlined, FileWordOutlined, FileExcelOutlined, FileUnknownOutlined } from '@ant-design/icons';

const { Title } = Typography;

interface AttachmentsTabProps {
  docAttachments: any[];
}

const AttachmentsTab: React.FC<AttachmentsTabProps> = ({ docAttachments }) => {
  return (
    <div style={{ padding: 24 }}>
      <Title level={5} style={{ marginBottom: 16, textTransform: 'uppercase' }}>
        <FileImageOutlined style={{ marginRight: 8 }} />
        Hồ sơ tài sản
      </Title>
      {docAttachments.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
          {docAttachments.map((att: any) => {
            const ext = att.file_name?.split('.').pop()?.toLowerCase() || '';
            let icon = <FileUnknownOutlined style={{ fontSize: 40, color: '#aaa' }} />;
            if (att.mime_type?.includes('pdf') || ext === 'pdf') icon = <FilePdfOutlined style={{ fontSize: 40, color: '#d4380d' }} />;
            else if (att.mime_type?.includes('word') || ['doc','docx'].includes(ext)) icon = <FileWordOutlined style={{ fontSize: 40, color: '#1890ff' }} />;
            else if (att.mime_type?.includes('excel') || ['xls','xlsx','csv'].includes(ext)) icon = <FileExcelOutlined style={{ fontSize: 40, color: '#52c41a' }} />;
            else if (att.mime_type?.startsWith('image') || ['jpg','jpeg','png','gif','bmp','webp'].includes(ext)) icon = <FileImageOutlined style={{ fontSize: 40, color: '#722ed1' }} />;
            return (
              <div key={att.id} style={{ width: 120, textAlign: 'center' }}>
                <a href={att.file_path} target="_blank" rel="noopener noreferrer">
                  {icon}
                </a>
                <div style={{ fontSize: 13, marginTop: 4, wordBreak: 'break-all' }}>{att.file_name}</div>
                <a href={att.file_path} download style={{ fontSize: 12, color: '#1890ff' }}>Tải về</a>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AttachmentsTab; 